import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Textarea } from '@/components/ui/textarea';
import { useQualityDetailContext } from '@/contexts/QualityContext';
import { DETAIL_MODE, DETAIL_TYPE, useDetailMode } from '@/hooks/useDetailMode';

const InformationDescription = () => {
  const { mode } = useDetailMode(DETAIL_TYPE.QUALITY);
  const { form, setFormByKey } = useQualityDetailContext();
  const { informationDescription } = form;

  return (
    <Card className="flex mb-4">
      <CardHeader className="pb-6 grow">
        <div className="flex gap-4 items-start justify-between">
          <CardTitle className="text-base font-medium w-1/4">
            Description of Quality Event *
          </CardTitle>
          <CardDescription className="grow">
            {mode === DETAIL_MODE.STATIC ? (
              informationDescription
            ) : (
              <Textarea
                className="font-mono resize-none"
                onChange={({ target }) =>
                  setFormByKey('informationDescription', target.value)
                }
                placeholder="Please include a description of the observed QE that has occurred..."
                rows={4}
                value={informationDescription}
              />
            )}
          </CardDescription>
        </div>
      </CardHeader>
    </Card>
  );
};

const InformationDetails = () => {
  const { mode } = useDetailMode(DETAIL_TYPE.QUALITY);
  const { form, setFormByKey } = useQualityDetailContext();
  const { informationDetails } = form;

  return (
    <Card className="flex mb-4">
      <CardHeader className="pb-6 grow">
        <div className="flex gap-4 items-start justify-between">
          <CardTitle className="text-base font-medium w-1/4">
            Details of the Quality Event *
          </CardTitle>
          <CardDescription className="grow">
            {mode === DETAIL_MODE.STATIC ? (
              informationDetails
            ) : (
              <Textarea
                className="font-mono resize-none"
                onChange={({ target }) =>
                  setFormByKey('informationDetails', target.value)
                }
                placeholder="Why, when, and where it happens?  What has it affected?..."
                rows={4}
                value={informationDetails}
              />
            )}
          </CardDescription>
        </div>
      </CardHeader>
    </Card>
  );
};

const InformationFile = () => {
  const { mode } = useDetailMode(DETAIL_TYPE.QUALITY);
  const { form, setFormByKey } = useQualityDetailContext();
  const { informationFile } = form;

  return (
    <Card className="flex mb-4">
      <CardHeader className="pb-6 grow">
        <div className="flex gap-4 items-start justify-between">
          <CardTitle className="text-base font-medium w-1/4">
            File Location *
          </CardTitle>
          <CardDescription className="grow">
            {mode === DETAIL_MODE.STATIC ? (
              informationFile
            ) : (
              <Textarea
                className="font-mono resize-none"
                onChange={({ target }) =>
                  setFormByKey('informationFile', target.value)
                }
                rows={1}
                value={informationFile}
              />
            )}
          </CardDescription>
        </div>
      </CardHeader>
    </Card>
  );
};
const InformationRemarks = () => {
  const { mode } = useDetailMode(DETAIL_TYPE.QUALITY);
  const { form, setFormByKey } = useQualityDetailContext();
  const { informationRemark } = form;

  return (
    <Card className="flex mb-4">
      <CardHeader className="pb-6 grow">
        <div className="flex gap-4 items-start justify-between">
          <CardTitle className="text-base font-medium w-1/4">
            Remarks (If any)
          </CardTitle>
          <CardDescription className="grow">
            {mode === DETAIL_MODE.STATIC ? (
              informationRemark
            ) : (
              <Textarea
                className="font-mono resize-none"
                onChange={({ target }) =>
                  setFormByKey('informationRemark', target.value)
                }
                rows={1}
                value={informationRemark}
              />
            )}
          </CardDescription>
        </div>
      </CardHeader>
    </Card>
  );
};

const QualityInformationView = () => {
  return (
    <div className="space-y-4">
      <InformationDescription />
      <InformationDetails />
      <InformationFile />
      <InformationRemarks />
    </div>
  );
};

export default QualityInformationView;
